import axios from 'axios';
import saveAs from 'js-file-download';
import ContentDisposition from 'content-disposition';

// TODO : getTokenの削除
function getToken() {
  return sessionStorage.getItem("token");
};

export default {
  get: (path, token) => {
    var params;
    if (!token) {
      token = getToken();
    }
    if (token) {
      params = {
        headers: {
            Authorization: `Bearer ${token}`
        }
      }
    }
    return axios.get(path, params);
  },

  post: (path, request, token) => {
    var params = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    if (!token) {
      token = getToken();
    }
    if (token) {
      params.headers.Authorization = `Bearer ${token}`;
    }
    return axios.post(path, JSON.stringify(request), params);
  },

  put: (path, request, token) => {
    var params = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    if (!token) {
      token = getToken();
    }
    if (token) {
      params.headers.Authorization = `Bearer ${token}`;
    }
    return axios.put(path, JSON.stringify(request), params);
  },

  download: (path, token) => {
    var params = {
      responseType: 'blob'
    };
    if (!token) {
      token = getToken();
    }
    if (token) {
      params.headers = {
        Authorization: `Bearer ${token}`
      };
    }
    return axios.get(path, params)
      .then(response => {
        const contentDisposition = ContentDisposition.parse(response.headers['content-disposition']);
        saveAs(response.data, contentDisposition.parameters.filename);
      });
  }
}